import gql from 'graphql-tag';

const query = gql

  `
query SearchArtists($searchText: String!, $paging: Paging) {
    searchArtists(searchText: $searchText, paging: $paging) {
    _id
    name
    image
  }
}
`;

export default query;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/queries/artist-search.model.ts